import {addYears, isSameMonth, format, addMonths} from 'date-fns';

export const appendYearsToMonthList = (startDate = new Date('2008-01-01'), endDate = new Date(), yearCount = 1) => {
  // Adding 1 Month on Top of the 1 Year Adding Logic to Mitigate the Last while Loop Condition of same Month
  endDate = addMonths(endDate, 1);
  endDate = addYears(endDate, yearCount);

  let monthList = [], current = startDate;

  // console.log(isSameMonth(new Date('01-01-2021'), endDate));

  while (!isSameMonth(current, endDate)) {
    monthList.push({
      month: format(current, 'MMMM'),
      month_val: format(current, 'YYYYMM'),
      year: format(current, 'YYYY'),
    });
    current = addMonths(current, 1);
  }

  return monthList;
}

export const bookingMonthToDate = ({ month_val }) => {
  // console.log("Log: bookingMonthToDate -> `${year}-${month}-01`", `${sliceMonthVal(month_val)}-01`)
  return new Date(`${sliceMonthVal(`${month_val}`)}-01`);
}

const sliceMonthVal = (s) => s.slice(0, 4) + '-' + s.slice(4)

// console.log(append12Months());
